import React, { createContext, useContext, useMemo, useState } from 'react';

interface AbacusFocusContextValue {
  focusActive: boolean;
  setFocusActive: (active: boolean) => void;
}

const AbacusFocusContext = createContext<AbacusFocusContextValue | null>(null);

/** Hides the student app header and footer while a mental drill is open. */
export const AbacusFocusProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [focusActive, setFocusActive] = useState(false);
  const value = useMemo(() => ({ focusActive, setFocusActive }), [focusActive]);
  return <AbacusFocusContext.Provider value={value}>{children}</AbacusFocusContext.Provider>;
};

export function useAbacusFocus(): AbacusFocusContextValue {
  const value = useContext(AbacusFocusContext);
  if (!value) {
    return { focusActive: false, setFocusActive: () => undefined };
  }
  return value;
}
